import { render } from "./change-pass-required.vue?vue&type=template&id=4964c8bd&scoped=true&ts=true"
import script from "./change-pass-required.vue?vue&type=script&lang=ts"
export * from "./change-pass-required.vue?vue&type=script&lang=ts"

import "./change-pass-required.vue?vue&type=style&index=0&id=4964c8bd&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4964c8bd"]])

export default __exports__